import InstitutionFuturesClientCategorisationForm from '@/features/institution/futures/client-categorisation/components/form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionFuturesClientCategorisationPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="clientCategorisation" detailsType={INSTITUTION_DETAILS_TYPE.FUTURES}>
      <InstitutionFuturesClientCategorisationForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionFuturesClientCategorisationPage.displayName = 'InstitutionFuturesClientCategorisationPage';

export default InstitutionFuturesClientCategorisationPage;
